import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Loader2, Mail, ArrowLeft, CheckCircle2, AlertCircle } from "lucide-react";

export function ForgotPassword({ initialEmail, onBack }) {
  const [email, setEmail] = useState(initialEmail || "");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
      <div>
        <h2 className="text-base font-bold text-slate-900">Reset your password</h2>
        <p className="text-sm text-slate-500">Enter your work email and we'll send you a link to choose a new password.</p>
      </div>
      {sent ? (
        <div className="flex items-start gap-2 text-sm text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2.5" data-testid="forgot-sent">
          <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" /><span>{sent}</span>
        </div>
      ) : (
        <>
          <div className="relative">
            <Mail className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-slate-400" />
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="you@company.com" data-testid="forgot-email-input"
              className="w-full h-12 rounded-xl border border-slate-200 bg-white pl-11 pr-3 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100" />
          </div>
          {error && (
            <div className="flex items-start gap-2 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2" data-testid="forgot-error">
              <AlertCircle className="w-4 h-4 mt-0.5 shrink-0" /><span>{error}</span>
            </div>
          )}
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full h-12 rounded-xl bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white font-semibold flex items-center justify-center shadow-lg shadow-indigo-600/25 transition-colors disabled:opacity-60">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </button>
        </>
      )}
      <button type="button" onClick={onBack} className="flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700" data-testid="forgot-back">
        <ArrowLeft className="w-4 h-4" /> Back to sign in
      </button>
    </form>
  );
}
